import Billing from './billing.view.vue';
import BillingInfo from './billing-info/billing-info.component.vue';
import BillingInfoV2 from './billing-info-v2/billing-info-v2.component.vue';
import BillingDataTable from './billing-datatable/billing-datatable.component.vue';

export default [
  {
    path: '/billing',
    name: 'Billing',
    component: Billing,
    children: [
      {
        path: '/billing',
        props: true,
        name: 'BillingDataTable',
        component: BillingDataTable,
      },
      {
        path: '/billing/:billingId/info/:businessUnitId',
        props: true,
        name: 'FaturamentoInfo',
        component: BillingInfo,
      },
      {
        path: '/billing/:billingId/info-v2/:businessUnitId',
        props: true,
        name: 'FaturamentoInfoV2',
        component: BillingInfoV2,
      },
      {
        path: '/billing/:status',
        component: BillingDataTable,
        name: 'BillingDataTableStatus',
      },
      {
        path: '/billing/:status/:competence',
        component: BillingDataTable,
        name: 'Faturamento',
      },
    ],
  },
];
